jQuery.feature_import("js-meal-information",
  () => require("./meal-information.js"),
  mod => mod.feature_js_meal_information
);